<template>
  <div id="ac-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 139.49 139.49">
      <title>wc</title>
      <rect class="a" width="139.49" height="139.49" />
      <circle class="b" cx="443.17" cy="250.61" r="31.79" transform="translate(-435.24 4.74) rotate(-22.97)" />
      <line class="b" x1="53.05" y1="113.2" x2="88.13" y2="113.2" />
      <line class="b" x1="70.59" y1="130.74" x2="70.59" y2="95.66" />
      <line class="b" x1="116.84" y1="12.75" x2="91.22" y2="38.37" />
      <polyline class="b" points="116.83 34.09 116.83 12.75 95.5 12.75" />
      <line class="b" x1="22.66" y1="12.75" x2="49.07" y2="39.16" />
      <polyline class="b" points="43.99 12.75 22.66 12.75 22.66 34.09" />
      <line class="b" x1="29.54" y1="39.58" x2="49.34" y2="19.78" />
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
svg {
  width: 100%;
}

.a {
  fill: #c9caca;
}
.b {
  fill: none;
  stroke: #231815;
  stroke-miterlimit: 10;
  stroke-width: 7px;
}
</style>
